export default __webpack_public_path__ + "static/media/doctor.0484ebdc.png";